const SET_USER = '/app/SET_USER';
const SET_TOKEN = '/app/SET_TOKEN';
const REVOKE_ACCESS = '/app/REVOKE_ACCESS';
const SET_ACTIVE_CLIENT = '/app/SET_ACTIVE_CLIENT';
const SET_SIDE_NAV_PINNED = '/app/SET_SIDE_NAV_PINNED';
const SHOW_READY_UPGRADE_MODAL = '/app/SHOW_READY_UPGRADE_MODAL';
const SHOW_START_PLAN_MODAL = '/app/SHOW_START_PLAN_MODAL';

export default {
    SET_USER,
    SET_TOKEN,
    REVOKE_ACCESS,
    SET_ACTIVE_CLIENT,
    SET_SIDE_NAV_PINNED,
    SHOW_READY_UPGRADE_MODAL,
    SHOW_START_PLAN_MODAL,
};
